<h1 mat-dialog-title class="text-center dialogHeader blueHeader">
  Change Password
</h1>
<mat-dialog-content class="contentWid">
  <div class="col-md-12 loggedin-bg">
    <div class="row mt-3">
      <div class="col-md-4">
        <label for="oldPasswordInput" class="mt-2">Old Password</label>
      </div>
      <div class="col-md-8">
        <label
          for="oldPasswordInput"
          class="fa fa-eye-slash eye"
          [ngClass]="{
            'fa-eye-slash': showOldPassword,
            'fa-eye': !showOldPassword
          }"
          (click)="
            oldPasswordInput.type =
              oldPasswordInput.type == 'password' ? 'text' : 'password';
            showOldPassword = !showOldPassword
          "
        ></label>
        <input
          type="password"
          [(ngModel)]="oldPassword"
          [ngModelOptions]="{ standalone: true }"
          class="form-control ml-3"
          maxlength="30"
          id="oldPasswordInput"
          #oldPasswordInput
          placeholder="Old Password"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-4">
        <label for="newPasswordInput" class="mt-2">New Password</label>
      </div>
      <div class="col-md-8">
        <label
          for="newPasswordInput"
          class="fa fa-eye-slash eye"
          [ngClass]="{
            'fa-eye-slash': showNewPassword,
            'fa-eye': !showNewPassword
          }"
          (click)="
            newPasswordInput.type =
              newPasswordInput.type == 'password' ? 'text' : 'password';
            showNewPassword = !showNewPassword
          "
        ></label>
        <input
          type="password"
          [(ngModel)]="newPassword"
          [ngModelOptions]="{ standalone: true }"
          class="form-control ml-3"
          maxlength="30"
          id="newPasswordInput"
          #newPasswordInput
          placeholder="New Password"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-4">
        <label for="confirmPasswordInput" class="mt-2">Confirm Password</label>
      </div>
      <div class="col-md-8">
        <label
          for="confirmPasswordInput"
          class="fa fa-eye-slash eye"
          [ngClass]="{
            'fa-eye-slash': shownConfirmPassword,
            'fa-eye': !shownConfirmPassword
          }"
          (click)="
            confirmPasswordInput.type =
              confirmPasswordInput.type == 'password' ? 'text' : 'password';
            shownConfirmPassword = !shownConfirmPassword
          "
        ></label>
        <input
          type="password"
          [(ngModel)]="confirmPassword"
          [ngModelOptions]="{ standalone: true }"
          maxlength="30"
          class="form-control ml-3"
          id="confirmPasswordInput"
          #confirmPasswordInput
          placeholder="Confirm Password"
        />
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="col-md-8 offset-md-3">
    <button
      mat-button
      class="btnWidth blankTurquoise mr-4 btn wid"
      (click)="dialogRef.close(false)"
    >
      CANCEL
    </button>
    <button
      mat-button
      class="btnWidth turquoiseBtn btn wid ml-4"
      (click)="changePassword()"
    >
      CHANGE
    </button>
  </div>
</mat-dialog-actions>
